var map = {
	"./de/warrior-name.png": "3ffb",
	"./en/warrior-name.png": "FqAU",
	"./es/warrior-name.png": "wfpX",
	"./fr/warrior-name.png": "v8/K",
	"./ja/warrior-name.png": "SCJN",
	"./ko/warrior-name.png": "etVS",
	"./pt/warrior-name.png": "FgQl",
	"./ru/warrior-name.png": "9Hn4",
	"./th/warrior-name.png": "hFYU",
	"./zh-Hant/warrior-name.png": "imkl"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TR/i";